import {useCallback, useState} from 'react';
import {styled} from 'styled-components';
import {useLocation} from 'wouter';

import {Button, NavButton} from '@shared-web/components/core/button';
import {Spacing} from '@shared-web/components/core/spacing';

import {TopBarApp} from '@src/components/top_bar_app';
import {createProject} from '@src/lib/projects_stores';

export const CreateProjectPage: React.FC = () => {
  const [_, setLocation] = useLocation();
  const [sexes, setSexes] = useState<('boy' | 'girl')[]>(['boy', 'girl']);

  const handleBoyClick = useCallback(() => setSexes(['boy']), []);
  const handleGirlClick = useCallback(() => setSexes(['girl']), []);
  const handleBothClick = useCallback(() => setSexes(['boy', 'girl']), []);

  const handleCreateClick = useCallback(() => {
    console.log('handleCreateClick');
    createProject({sexes});
    setLocation('/');
  }, [setLocation, sexes]);

  return (
    <TopBarApp
      left={<NavButton to="/">Retour</NavButton>}
      center={<Spacing height={'3rem'} />}
      right="Nouvelle recherche"
    >
      <Content>
        <SexForm>
          <SexTitle>Type de prénoms</SexTitle>
          <SexLine>
            <Sex onClick={handleBoyClick} $selected={sexes.length === 1 && sexes.includes('boy')}>
              Garçon
            </Sex>
            <Sex onClick={handleGirlClick} $selected={sexes.length === 1 && sexes.includes('girl')}>
              Fille
            </Sex>
            <Sex onClick={handleBothClick} $selected={sexes.length === 2}>
              Les deux
            </Sex>
          </SexLine>
        </SexForm>
        <Button expand onClick={handleCreateClick}>
          Créer la recherche
        </Button>
      </Content>
    </TopBarApp>
  );
};
CreateProjectPage.displayName = 'CreateProjectPage';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  padding-bottom: env(safe-area-inset-bottom, 1rem);
`;

const SexForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const SexTitle = styled.div`
  font-size: 1.1rem;
  color: #888;
`;

const SexLine = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const Sex = styled.div<{$selected: boolean}>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  width: 30%;
  font-size: 1rem;
  background-color: #0000ff11;
  border: solid 2px transparent;
  user-select: none;
  cursor: pointer;
  border-radius: 0.5rem;
  ${p =>
    p.$selected
      ? `
        border-color: #0000ff33;
    `
      : false}
`;
